export {
  AUTH_TOKEN_STORAGE_KEY,
  clearPersistedAuthToken,
  getStoredAuthToken,
  persistAuthToken,
} from "../lib/authStorage";

export const hydrateSessionAuthToken = () => {
  let token = "";
  try {
    token =
      sessionStorage.getItem("user_auth_token") ||
      localStorage.getItem("user_auth_token") ||
      window.__authToken ||
      "";
    if (token) {
      sessionStorage.setItem("user_auth_token", token);
      window.__authToken = token;
    }
  } catch {
    // Storage can be unavailable in private/locked-down browser contexts.
  }
  return token;
};
